import { NgModule } from "@angular/core";
import {
  CommonModule,
  CurrencyPipe,
  DatePipe,
  DecimalPipe,
  registerLocaleData,
} from "@angular/common";
import { NzTreeViewModule } from "ng-zorro-antd/tree-view";
import { NzAffixModule } from "ng-zorro-antd/affix";
import { NzAlertModule } from "ng-zorro-antd/alert";
import { NzAnchorModule } from "ng-zorro-antd/anchor";
import { NzAutocompleteModule } from "ng-zorro-antd/auto-complete";
import { NzAvatarModule } from "ng-zorro-antd/avatar";
import { NzBackTopModule } from "ng-zorro-antd/back-top";
import { NzBadgeModule } from "ng-zorro-antd/badge";
import { NzBreadCrumbModule } from "ng-zorro-antd/breadcrumb";
import { NzButtonModule } from "ng-zorro-antd/button";
import { NzCalendarModule } from "ng-zorro-antd/calendar";
import { NzCardModule } from "ng-zorro-antd/card";
import { NzCarouselModule } from "ng-zorro-antd/carousel";
import { NzCascaderModule } from "ng-zorro-antd/cascader";
import { NzCheckboxModule } from "ng-zorro-antd/checkbox";
import { NzCollapseModule } from "ng-zorro-antd/collapse";
import { NzCommentModule } from "ng-zorro-antd/comment";
import { NzDatePickerModule } from "ng-zorro-antd/date-picker";
import { NzDescriptionsModule } from "ng-zorro-antd/descriptions";
import { NzDividerModule } from "ng-zorro-antd/divider";
import { NzDrawerModule } from "ng-zorro-antd/drawer";
import { NzDropDownModule } from "ng-zorro-antd/dropdown";
import { NzEmptyModule } from "ng-zorro-antd/empty";
import { NzFormModule } from "ng-zorro-antd/form";
import { NzGridModule } from "ng-zorro-antd/grid";
import { NzI18nModule } from "ng-zorro-antd/i18n";
import { NzInputModule } from "ng-zorro-antd/input";
import { NzInputNumberModule } from "ng-zorro-antd/input-number";
import { NzLayoutModule } from "ng-zorro-antd/layout";
import { NzListModule } from "ng-zorro-antd/list";
import { NzMentionModule } from "ng-zorro-antd/mention";
import { NzMenuModule } from "ng-zorro-antd/menu";
import { NzMessageContainerComponent } from "ng-zorro-antd/message";
import { NzModalModule } from "ng-zorro-antd/modal";
import { NzNotificationContainerComponent } from "ng-zorro-antd/notification";
import { NzPageHeaderModule } from "ng-zorro-antd/page-header";
import { NzPaginationModule } from "ng-zorro-antd/pagination";
import { NzPopconfirmModule } from "ng-zorro-antd/popconfirm";
import { NzPopoverModule } from "ng-zorro-antd/popover";
import { NzProgressModule } from "ng-zorro-antd/progress";
import { NzRadioModule } from "ng-zorro-antd/radio";
import { NzRateModule } from "ng-zorro-antd/rate";
import { NzResultModule } from "ng-zorro-antd/result";
import { NzSelectModule } from "ng-zorro-antd/select";
import { NzSkeletonModule } from "ng-zorro-antd/skeleton";
import { NzSliderModule } from "ng-zorro-antd/slider";
import { NzSpinModule } from "ng-zorro-antd/spin";
import { NzStatisticModule } from "ng-zorro-antd/statistic";
import { NzStepsModule } from "ng-zorro-antd/steps";
import { NzSwitchModule } from "ng-zorro-antd/switch";
import { NzTableModule } from "ng-zorro-antd/table";
import { NzTabsModule } from "ng-zorro-antd/tabs";
import { NzTagModule } from "ng-zorro-antd/tag";
import { NzTimePickerModule } from "ng-zorro-antd/time-picker";
import { NzTimelineModule } from "ng-zorro-antd/timeline";
import { NzToolTipModule } from "ng-zorro-antd/tooltip";
import { NzTransferModule } from "ng-zorro-antd/transfer";
import { NzTreeModule } from "ng-zorro-antd/tree";
import { NzTreeSelectModule } from "ng-zorro-antd/tree-select";
import { NzTypographyModule } from "ng-zorro-antd/typography";
import { NzUploadModule } from "ng-zorro-antd/upload";
import { NzResizableModule } from "ng-zorro-antd/resizable";
import { NzSpaceModule } from "ng-zorro-antd/space";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { NzIconModule, NZ_ICONS } from "ng-zorro-antd/icon";
import { NZ_ICON_DEFINITIONS } from "./ng-zorro-icons";
import en from "@angular/common/locales/en";
import { NzConfig, NZ_CONFIG } from "ng-zorro-antd/core/config";
import { AddUpdateUserComponent } from "./common/add-update-user/add-update-user.component";
import { NgMultiSelectDropDownModule } from "ng-multiselect-dropdown";
import { ChangepasswordComponent } from "./common/changepassword/changepassword.component";
import {
  NgxMaskDirective,
  IConfig,
  provideEnvironmentNgxMask,
  provideNgxMask,
  NgxMaskPipe,
} from "ngx-mask";
import { SelectModule } from "select/select.module";
import { AddUpdateInvestmentsComponent } from "./common/add-update-investments/add-update-investments.component";
import { AddUpdateProgramComponent } from "./common/add-update-program/add-update-program.component";
import { InvestorHistoryComponent } from "./common/investor-history/investor-history.component";
import { ManageProgramsComponent } from "./common/manage-programs/manage-programs.component";
import { NewInvestorVendorComponent } from "./common/new-investor-vendor/new-investor-vendor.component";
import { NotificationsAnnouncementsComponent } from "./common/notifications-announcements/notifications-announcements.component";
import { AddInvestorFormComponent } from "./common/add-investor-form/add-investor-form.component";
import { AddVendorFormComponent } from "./common/add-vendor-form/add-vendor-form.component";
import { ManageTagsComponent } from "./common/manage-tags/manage-tags.component";
import { ManagetransactionComponent } from "./common/managetransaction/managetransaction.component";
import { EditVendorDetailsComponent } from "./common/edit-vendor-details/edit-vendor-details.component";
import { CancelTransactionComponent } from "./common/cancel-transaction/cancel-transaction.component";
import { ScrollingModule } from "@angular/cdk/scrolling";
// import { NgIdleKeepaliveModule } from '@ng-idle/keepalive';
import { RouterModule } from "@angular/router";
import { TextMaskModule } from "../../angular2TextMask";
import { TagFormComponent } from "./common/tag-form/tag-form.component";
import { DragDropModule } from "@angular/cdk/drag-drop";
import { SharedPrimitivesModule } from "./modules/shared-primitives.module";

const maskConfigFunction: () => Partial<IConfig> = () => {
  return {
    validation: false,
  };
};
const ngZorroConfig: NzConfig = {
  message: { nzMaxStack: 1 },
};
registerLocaleData(en);

@NgModule({
  declarations: [
    AddUpdateUserComponent,
    ChangepasswordComponent,
    AddUpdateInvestmentsComponent,
    AddUpdateProgramComponent,
    InvestorHistoryComponent,
    ManageProgramsComponent,
    NewInvestorVendorComponent,
    NotificationsAnnouncementsComponent,
    AddInvestorFormComponent,
    AddVendorFormComponent,
    ManageTagsComponent,
    ManagetransactionComponent,
    EditVendorDetailsComponent,
    CancelTransactionComponent,
    TagFormComponent,
  ],
  imports: [
    RouterModule,
    TextMaskModule,
    NgxMaskDirective,
    NgxMaskPipe,
    // NgxMaskModule.forRoot(maskConfig),
    SharedPrimitivesModule,
    NzAffixModule,
    NzAlertModule,
    NzAnchorModule,
    NzAutocompleteModule,
    NzAvatarModule,
    NzBackTopModule,
    NzBadgeModule,
    NzButtonModule,
    NzBreadCrumbModule,
    NzCalendarModule,
    NzCardModule,
    NzCarouselModule,
    NzCascaderModule,
    NzCheckboxModule,
    NzCollapseModule,
    NzCommentModule,
    NzDatePickerModule,
    NzDescriptionsModule,
    NzDividerModule,
    NzDrawerModule,
    NzDropDownModule,
    NzEmptyModule,
    NzFormModule,
    NzGridModule,
    NzI18nModule,
    NzIconModule,
    NzInputModule,
    NzInputNumberModule,
    NzLayoutModule,
    NzListModule,
    NzMentionModule,
    NzMenuModule,
    NzMessageContainerComponent,
    NzModalModule,
    NzNotificationContainerComponent,
    NzPageHeaderModule,
    NzPaginationModule,
    NzPopconfirmModule,
    NzPopoverModule,
    NzProgressModule,
    NzRadioModule,
    NzRateModule,
    NzResultModule,
    NzSelectModule,
    NzSkeletonModule,
    NzSliderModule,
    NzSpinModule,
    NzStatisticModule,
    NzStepsModule,
    NzSwitchModule,
    NzTableModule,
    NzTabsModule,
    NzTagModule,
    NzTimePickerModule,
    NzTimelineModule,
    NzToolTipModule,
    NzTransferModule,
    NzTreeModule,
    NzTreeSelectModule,
    NzTypographyModule,
    NzUploadModule,
    NzResizableModule,
    NzTreeViewModule,
    NgMultiSelectDropDownModule,
    NzSpaceModule,
    SelectModule,
    ScrollingModule,
    DragDropModule,
    // NgIdleKeepaliveModule.forRoot(),
    // ProgramperiodComponent
  ],
  exports: [
    // NgxMaskModule,
    TextMaskModule,
    SharedPrimitivesModule,
    NzAffixModule,
    NzAlertModule,
    NzAnchorModule,
    NzAutocompleteModule,
    NzAvatarModule,
    NzBackTopModule,
    NzBadgeModule,
    NzButtonModule,
    NzBreadCrumbModule,
    NzCalendarModule,
    NzCardModule,
    NzCarouselModule,
    NzCascaderModule,
    NzCheckboxModule,
    NzCollapseModule,
    NzCommentModule,
    NzDatePickerModule,
    NzDescriptionsModule,
    NzDividerModule,
    NzDrawerModule,
    NzDropDownModule,
    NzEmptyModule,
    NzFormModule,
    NzGridModule,
    NzI18nModule,
    NzIconModule,
    NzInputModule,
    NzInputNumberModule,
    NzLayoutModule,
    NzListModule,
    NzMentionModule,
    NzMenuModule,
    NzMessageContainerComponent,
    NzModalModule,
    NzNotificationContainerComponent,
    NzPageHeaderModule,
    NzPaginationModule,
    NzPopconfirmModule,
    NzPopoverModule,
    NzProgressModule,
    NzRadioModule,
    NzRateModule,
    NzResultModule,
    NzSelectModule,
    NzSkeletonModule,
    NzSliderModule,
    NzSpinModule,
    NzStatisticModule,
    NzStepsModule,
    NzSwitchModule,
    NzTableModule,
    NzTabsModule,
    NzTagModule,
    NzTimePickerModule,
    NzTimelineModule,
    NzToolTipModule,
    NzTransferModule,
    NzTreeModule,
    NzTreeSelectModule,
    NzTypographyModule,
    NzUploadModule,
    NzResizableModule,
    NzSpaceModule,
    NzTreeViewModule,
    AddUpdateUserComponent,
    ChangepasswordComponent,
    SelectModule,
    AddUpdateInvestmentsComponent,
    AddUpdateProgramComponent,
    ManageProgramsComponent,
    InvestorHistoryComponent,
    NewInvestorVendorComponent,
    NotificationsAnnouncementsComponent,
    AddVendorFormComponent,
    ManageTagsComponent,
    ManagetransactionComponent,
    EditVendorDetailsComponent,
    CancelTransactionComponent,
    AddInvestorFormComponent,
    NgxMaskDirective,
    NgxMaskPipe,
    DragDropModule,
  ],
  providers: [
    {
      provide: NZ_ICONS,
      useValue: NZ_ICON_DEFINITIONS,
    },
    { provide: NZ_CONFIG, useValue: ngZorroConfig },
    provideEnvironmentNgxMask(maskConfigFunction),
    provideNgxMask(),
    DatePipe,
    DecimalPipe,
    CurrencyPipe,
  ],
})
export class SharedModule {}
